import { useContext } from 'react';
import ModeNightIcon from '@mui/icons-material/ModeNight';
import LightModeIcon from '@mui/icons-material/LightMode'; 
import { IconButton, Tooltip, useTheme } from '@mui/material';
import PropTypes from 'prop-types';

import { ColorModeContext } from '../../theme/ColorModeContext';

export default function Theme({ ONLY_ICON }) {
  const { toggleColorMode } = useContext(ColorModeContext);
  const theme = useTheme();

  return (
    <Tooltip title="መልክ" arrow>
      <IconButton
        sx={{
          padding: 0,
          width: 44,
          height: 44,
        }}
        onClick={toggleColorMode}
      >
        {theme.palette.mode === 'light' ? <ModeNightIcon /> : <LightModeIcon />}
      </IconButton>
      {!ONLY_ICON && (theme.palette.mode === 'light' ? <> ጨለማ ሁነታ </> : <> የብርሃን ሁነታ </>)}
    </Tooltip>
  );
}

Theme.propTypes = {
  ONLY_ICON: PropTypes.bool.isRequired,
};
